import type { CompiledPublicTile } from '@shared/types/domainConfig';
import { tileColSpanClass } from '@shared/lib/tileGrid';
import { cn } from '@shared/lib/cn';
import { TileIcon, TileLabel, homeTileButtonClass } from '@features/dashboard/TileIcon';
import { PanicSosBadge } from '@features/panic/PanicSosBadge';

interface QuickTileProps {
  tile: CompiledPublicTile;
  onSelect: () => void;
  className?: string;
}

/** The Panic module gets a dedicated SOS treatment instead of icon + label. */
function isPanicTile(tile: CompiledPublicTile): boolean {
  return (
    tile.module_required === 'panic' ||
    (tile.action_type === 'module' && tile.action_config?.module_route === '/app/panic')
  );
}

/**
 * Home quick-link tile — solid white card, primary-tinted icon, drop shadow.
 * Panic is special-cased to a white "SOS" on a red disc (no icon/label).
 */
export function QuickTile({ tile, onSelect, className }: QuickTileProps): JSX.Element {
  return (
    <li className={cn(tileColSpanClass(tile.column_span), className)}>
      <button type="button" onClick={onSelect} className={homeTileButtonClass}>
        {isPanicTile(tile) ? (
          <span className="flex h-full w-full items-center justify-center">
            <PanicSosBadge className="h-12 w-12 text-sm" />
          </span>
        ) : (
          <>
            <TileIcon imageUrl={tile.image_url} label={tile.label} />
            <TileLabel label={tile.label} />
          </>
        )}
      </button>
    </li>
  );
}
